














import {
    Vue, Component, Prop, Mixins, PropSync,
} from 'vue-property-decorator'

@Component
export default class Pagination extends Vue {
    @Prop({default: 0}) total!: number

    @Prop({
        default: () => [],
    }) pageSizes!: number[]

    @PropSync('page', {type: Number, default: 1}) currentPage!: number

    @PropSync('pageSize', {type: Number, default: 10}) currentPageSize!: number

    handleCurrentChange(val) {
        this.$emit('changePage', val)
    }

    handleSizeChange(val) {
        this.$emit('changePageSize', val)
    }
}
